import { useMutableRef } from '@carnica/utils/hooks';
import { useCallback } from 'react';
import { addQueuedMessage, selectCaptchaData, useCaptchaContext } from "../../../../entities/captcha/model";
import { setIsNoNAuthCaptchaStage } from "../../../../entities/message/model";
import { ymPushViewHelloCaptchaMes } from "../../../../shared/analytics";
import { useAppDispatch, useAppSelector } from "../../../../shared/model";
export var useCaptchaScript = function useCaptchaScript(zoneType) {
  var dispatch = useAppDispatch();
  var _useCaptchaContext = useCaptchaContext(),
    sendCaptchaMessage = _useCaptchaContext.sendCaptchaMessage,
    handleChangeStage = _useCaptchaContext.handleChangeStage,
    generateCaptchaMessage = _useCaptchaContext.generateCaptchaMessage,
    captchaStage = _useCaptchaContext.captchaStage;
  var captchaRef = useMutableRef(useAppSelector(selectCaptchaData));
  return useCallback(function (socketMessage, historyMessage) {
    if (captchaStage === 'init') {
      dispatch(setIsNoNAuthCaptchaStage(true));
      dispatch(addQueuedMessage(historyMessage));
      handleChangeStage('start');
      ymPushViewHelloCaptchaMes(zoneType);
      return;
    }
    if (!captchaRef.current) {
      dispatch(addQueuedMessage(historyMessage));
      void generateCaptchaMessage('captcha');
      return;
    }
    if (socketMessage) {
      void sendCaptchaMessage(socketMessage.data.message.text);
    }
  }, [zoneType, captchaStage]);
};